// extracted by mini-css-extract-plugin
module.exports =  {"container":"test_cards_list-module_container_d01d3","title":"test_cards_list-module_title_ebd74","required":"test_cards_list-module_required_f6146"};